import { wppage } from "./modules/wppage";
wppage();